









import Vue from 'vue'

export default Vue.extend({
  name: 'AmataTabsItem',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    isActive(): boolean {
      return this.$parent['value'] === this.value
    }
  },
  methods: {
    onClicked() {
      this.$parent.$emit('input', this.value)
    }
  }
})
